import React, { useState } from 'react';
import styled from 'styled-components/macro';
import { Label, Input, ViewPasswordEye } from '../../AccountProfile/ProfileStyles';
import Asterix from '../../../assets/asterix.svg';
import { formatPhoneNumber } from '../../../util/functions';
import { formatNameField } from '../../../util/validators';
import { useTranslation } from 'react-i18next';
import { eye } from '../../../assets/components/svgs';
import AddCircle from '../../../assets/addCircle.svg';
import InfoPopover from './InfoPopover';
import { SpinnerIconWrapper } from '../../primitives/inputs/BISearchAndClick';
import BiButton from '../../primitives/buttons/BiButton.primitive';
import ListView from '../../primitives/ListView/ListView';
import InputField from './InputField';
import DeleteIcon from '@heroicons/react/outline/TrashIcon';
import PlusIcon from '@heroicons/react/outline/PlusCircleIcon';
import { cloneDeep, isEmpty, isEqual, isUndefined } from 'lodash';

interface NewOrganizationSampleData {
  name?: string;
  phone?: string;
  fax?: string;
  address?: string;
  city?: string;
  zip?: string;
  state?: string;
  country?: string;
  roleName?: string;
  createdBy?: string;
}

interface InputFieldProps {
  type: string;
  title?: string;
  id: string;
  key?: string;
  label: string;
  placeholder: any;
  fieldKey: string;
  required: boolean;
  formData: NewOrganizationSampleData;
  setFormData: Function;
  formError: NewOrganizationSampleData;
  asterixFirst?: boolean;
  disabled?: boolean;
  className?: string;
  handleChange?: Function | null;
  onBlurhandler?: Function | null;
  min?: number;
  max?: number;
  autoComplete?: string;
  errorClass?: string;
  disableLabel?: boolean;
  validateField?: boolean;
  onClick?: Function | null;
  ref?: any;
  style?: any;
  step?: number;
  outline?: boolean;
  allowSplChar?: boolean;
  overrideValue?: any;
  popoverContent?: React.ReactNode;
  prefixValue?: string;
  isLoading?: boolean;
  CustomIcon?: any;
  subLabel?: string;
}
const Image = styled.img`
  width: 8px;
  height: 8px;
`;

const ErrorLabel = styled.span`
  fontsize: 11px;
  color: red;
`;

const ViewErrorContainer = styled.div`
  position: absolute;
  display: flex;
  justify-content: right;
  margin-left: auto;
  top: 28px;
  margin-right: 10px;
  right: 0;
`;

const InputFieldListing = ({
  type,
  id,
  label,
  placeholder,
  fieldKey,
  required,
  formData,
  setFormData,
  formError,
  asterixFirst,
  disabled,
  className,
  handleChange = null,
  onBlurhandler = null,
  min = 0,
  max = 0,
  autoComplete = '',
  errorClass = '',
  disableLabel = false,
  validateField = true,
  onClick,
  ref,
  style = {},
  outline = false,
  allowSplChar = false,
  title = '',
  overrideValue = '',
  popoverContent = null,
  prefixValue = '',
  isLoading = false,
  CustomIcon,
  subLabel = ''
}: InputFieldProps) => {
  const { t } = useTranslation();

  const listingEntries: any = formData[fieldKey as keyof NewOrganizationSampleData];
  const errorObj = formError[fieldKey as keyof NewOrganizationSampleData];
  const listingEntriesMap = listingEntries.map((ele: any) => {
    return { name: ele };
  });

  const [inputListingEntries, setInputListingEntries] = useState<any>(listingEntriesMap);

  const addItemFunction = () => {
    const name: string = '';
    setInputListingEntries([{ name }, ...inputListingEntries]);
  };

  const deleteFunction = (index: number) => {
    if (isUndefined(index) || index < 0 || index > inputListingEntries.length) {
      return;
    }
    let cloneArr = cloneDeep(inputListingEntries);
    cloneArr.splice(index, 1);

    setInputListingEntries(cloneArr);
    setFormData({
      ...formData,
      [fieldKey]: cloneArr.map((obj: any) => {
        return obj.name;
      })
    });
  };

  const updateFunction = (index: number, item: any) => {
    if (isUndefined(index) || index < 0 || index > inputListingEntries.length) {
      return;
    }
    inputListingEntries.splice(index, 1);
    inputListingEntries.splice(index, 0, item);
    setInputListingEntries([...inputListingEntries]);
    setFormData({
      ...formData,
      [fieldKey]: inputListingEntries.map((obj: any) => {
        return obj.name;
      })
    });
  };

  return (
    <div className="flex w-full flex-col">
      <div className="flex w-full flex-row">
        <div className="flex w-[90%] flex-col font-medium">
          <Label htmlFor={id}>
            {asterixFirst && required ? <Image src={Asterix} className="mr-1" /> : ''}
            {t(label)} {subLabel ? `(${t(subLabel)})` : ''}
            {required && !asterixFirst ? <Image src={Asterix} /> : ''}
            {popoverContent ? (
              <InfoPopover className="ml-2" content={popoverContent}></InfoPopover>
            ) : (
              ''
            )}
          </Label>
        </div>
        <div className="flex w-[6%] items-center">
          <PlusIcon
            data-testid="inputFieldListing-add"
            className={`mx-auto h-6 w-6 cursor-pointer text-gray-600 hover:text-black ${
              disabled && 'cursor-not-allowed bg-transparent'
            }`}
            onClick={() => {
              !disabled && addItemFunction && addItemFunction();
            }}
          />
        </div>
      </div>
      <ListView
        id="inputFieldListing-list"
        data-testid="inputFieldListing-list"
        containerClassName={`font-medium`}
        maxHeight="20rem"
      >
        {inputListingEntries.map((item: any, index: number) => {
          return (
            <div className={`mt-3 flex w-full flex-row`}>
              <div className={`flex ${!disabled ? 'w-[90%]' : 'w-[98%]'} flex-col`}>
                <InputField
                  type={'text'}
                  id={'redirect-uri'}
                  testId="redirect-uri"
                  label={''}
                  placeholder={`${t('T_KEY')} ${index + 1}`}
                  fieldKey={'name'}
                  asterixFirst={false}
                  required={false}
                  formData={item}
                  setFormData={setFormData}
                  formError={formError}
                  disabled={disabled}
                  handleChange={(e: any) => {
                    //setFormData({ ...item, name: e.target.value });
                    updateFunction && updateFunction(index, { ...item, name: e.target.value });
                  }}
                  min={1}
                  max={1024}
                />
                <ErrorLabel className={errorClass}>
                  {errorObj ? (errorObj[index] ? errorObj[index] : '') : ''}
                </ErrorLabel>
              </div>

              {!disabled && (
                <div className={`flex w-[6%] items-center`}>
                  <DeleteIcon
                    className={`mx-auto mt-2 h-6 w-6 cursor-pointer text-gray-600 hover:text-black ${
                      disabled && 'cursor-not-allowed bg-transparent'
                    }`}
                    onClick={() => {
                      !disabled && deleteFunction && deleteFunction(index);
                    }}
                    id="inputFieldListing-delete"
                    data-testid="inputFieldListing-delete"
                  />
                </div>
              )}
            </div>
          );
        })}
      </ListView>
    </div>
  );
};

export default React.memo(InputFieldListing);
